import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';
import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';

import PageSectionCardCarousel from 'components/page/sections/page-section-card-carousel';
import PageSectionCards, {
  PageSectionCardsProps,
} from 'components/page/sections/page-section-cards';

export const VideoChatBlockThreeContainer: FunctionComponent = () => {
  const props = {
    title: features.audioCalls.lxAudioCallsThreeBlockTitle,
    items: [
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/video-chat/video-chat-use-chat-1.svg`,
        title: features.audioCalls.lxAudioCallsThreeBlockSubtitleOne,
        text: features.audioCalls.lxAudioCallsThreeBlockBodyTextOne,
        titleTag: 'h3',
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/video-chat/video-chat-use-chat-2.svg`,
        title: features.audioCalls.lxAudioCallsThreeBlockSubtitleTwo,
        text: features.audioCalls.lxAudioCallsThreeBlockBodyTextTwo,
        titleTag: 'h3',
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/video-chat/video-chat-use-chat-3.svg`,
        title: features.audioCalls.lxAudioCallsThreeBlockSubtitleThree,
        text: features.audioCalls.lxAudioCallsThreeBlockBodyTextThree,
        titleTag: 'h3',
      },
    ] as PageSectionCardsProps['cards'],
  };

  const isMobile = useMediaQuery(MediaQueryWidth['navigation-full']);

  return (
    <>
      {isMobile ? (
        <PageSectionCardCarousel title={props.title} cards={props.items} />
      ) : (
        <PageSectionCards title={props.title} cards={props.items} color="orange" styling="filled" />
      )}
    </>
  );
};
